import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, IconButton } from "@mui/material";
import React, { useState } from "react";
import CommonSearch from "../CommonSearch/CommonSearch";
import QrContainer from "../QRCode/qrReader";
import { convertCase } from "../Helper/utils";
import "./CommonDialog.css";
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const CommonDialog = ({ getValues, openDialog, handleCloseDialog,
    hanldeScannerClick, openManual, setGetValues, handleQrScan,
    SearchData, handleSearchDrop, handleAddDialog, inputField,
    InProgress, inputHeader, handleValueChange, ReceiptTypeDrop,
    editMode, handleIpClick, errorMessage, disabledFields, pageName }) => {
    // const [openManual, setOpenManual] = useState(false);
    const { t } = useTranslation();

    return (
        <div>
            <Dialog open={openDialog}>
                <DialogTitle className='Modal-heading'>{t('Scan a Batch')}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleCloseDialog}
                        style={{ position: 'absolute', right: '18px', top: '10px' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className="transfer-data">
                        {openManual ? (
                            <div>
                                <CommonSearch
                                    inputFields={inputField}
                                    values={getValues}
                                    setValues={setGetValues}
                                    data={SearchData}
                                    errorMessage={errorMessage}
                                    handleInputClick={handleIpClick}
                                    disabledFields={disabledFields}
                                    handleDropdownClick={handleSearchDrop}
                                />
                                {InProgress && (InProgress.batchCall || InProgress.PorReceiptCall) && (
                                    <div className="d-grid">
                                        {inputHeader && inputHeader.map((header, index) => (
                                            header !== "item_Code" && header !== "item_Name" && header !== "issues_Batch" && (
                                                header === "Receipt_Type" ? (
                                                    // If the header is "Receipt_Type" and there are values in Receipt_Type_drop, render the dropdown
                                                    <TextField
                                                        key={index}
                                                        select
                                                        label={t(convertCase(header))}
                                                        variant="outlined"
                                                        onChange={(e) => handleValueChange(e, header)}
                                                        value={
                                                            getValues && getValues[header] !== undefined && getValues[header] !== null && !Number.isNaN(getValues[header])
                                                                ? getValues[header]
                                                                : ""
                                                        }
                                                        className="custom-modal-textfield"
                                                        style={{ marginBottom: '10px' }}
                                                        disabled={disabledFields && disabledFields.includes(header)}
                                                        error={errorMessage && errorMessage[header]}
                                                        helperText={errorMessage && errorMessage[header]}
                                                    >
                                                        {ReceiptTypeDrop && ReceiptTypeDrop.length > 0 ? (
                                                            ReceiptTypeDrop.map((option, optionIndex) => {
                                                                const key = Object.keys(option)[0];
                                                                return (
                                                                    <MenuItem key={optionIndex} value={option[key]}>
                                                                        {option[key]}
                                                                    </MenuItem>
                                                                );
                                                            })
                                                        ) : (
                                                            // Optionally, add a default "no options" item if ReceiptTypeDrop is empty
                                                            <MenuItem value="">
                                                                No options available
                                                            </MenuItem>
                                                        )}
                                                    </TextField>
                                                ) : (
                                                    // Otherwise, render a normal TextField
                                                    <TextField
                                                        key={index}
                                                        label={t(convertCase(header))}
                                                        variant="outlined"
                                                        onChange={(e) => handleValueChange(e, header)}
                                                        className="custom-modal-textfield"
                                                        value={getValues && getValues[header] !== null ? getValues[header] : ""}
                                                        style={{ marginBottom: '10px' }}
                                                        disabled={disabledFields && disabledFields.includes(header)}
                                                        error={errorMessage && errorMessage[header]}
                                                        helperText={errorMessage && errorMessage[header]}
                                                    />
                                                )
                                            )
                                        ))}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <QrContainer openManual={openManual} elementId="CommonDialog" onScan={handleQrScan} />

                            </div>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    {pageName !== 'ProductionFgissue' && pageName !== 'DisassembleReceipt' && (
                        openManual ? (
                            <Button onClick={() => hanldeScannerClick('scanner')} color="primary">
                                Scanner
                            </Button>
                        ) : (
                            <Button onClick={() => hanldeScannerClick('Manual')}>Manual Entry</Button>
                        )
                    )}

                    <Button onClick={() => handleCloseDialog()} className='Modal-cancel'>
                        Close
                    </Button>
                    <Button onClick={() => handleAddDialog()} className='Modal-submit'>{editMode ? 'Update' : 'Add'}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CommonDialog;